import Styled from 'styled-components'


export const Container = Styled.div`
margin-top: 20px;
margin: 0 2%;

margin-bottom: 30px;

@media(max-width: 800px) {
  margin: 0 5%;
}

`

export const H1 = Styled.h1`
text-align: center;
color: #0b3275;
font-weight: bold;
font-size: 34px;
margin-top: 40px;
margin-bottom: 40px;
`


export const Content = Styled.p`
font-size: 1rem;
color: var(--primary-color);
`

export const Strong = Styled.strong`
color: var(--primary-color);
font-size: 1.2rem;
`

export const Break = Styled.br`
`

export const Span = Styled.span`
font-size: 1.2rem;
`

export const ModalContent = Styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
`

export const ModalTitle = Styled.h2`
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 1.5rem 0;
  padding: 0 1rem;
`

export const ModalScrollable = Styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
  max-height: 400px;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const ModalText = Styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  
  ${Strong} {
    display: block;
    font-size: 1rem;
    font-weight: bold;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
  
  ${Break} {
    line-height: 1.6;
  }
`